import React from 'react';
import { slugify } from '@sbt-web/utils';
import { Button } from '@sbt-web/ui';
import classes from './index.module.scss.js';

const ShopLink = ({ impresapiuBase, ad, pulseInstance, }) => {
    const shopID = ad.advertiser.shopId;
    const shopName = ad.advertiser.shopName;
    if (!shopID || !shopName)
        return null;
    const url = `${impresapiuBase}/shops/${shopID}-${slugify(shopName)}`;
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        pulseInstance?.queueEvent({
            type: 'Click',
            object: {
                type: 'RedirectUrl',
                inReplyTo: {
                    '@id': `sdrn:subito:classified:${ad.urn}`,
                },
                url: {
                    description: url,
                    type: 'string',
                },
                page: {
                    pageType: 'listing',
                },
                search: {
                    '@id': sessionStorage.getItem('navigation_search_id'),
                },
            },
        });
        window.open(url);
    };
    return (React.createElement(Button, { classes: [classes.ellipses], design: "text", onClick: handleClick, size: "small", slim: true }, shopName));
};

export { ShopLink };
//# sourceMappingURL=index.js.map
